<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">

    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab"> VALET REGOLE </a>
      </label>
    </div>

    <div class="heading">

      <div class="button-wrapper">
        <a class="btn hvr-grow has-margin-right" routerLink="/expert/rules/nuovo">
          Aggiungi Regole
        </a>
      </div>
    </div>

    <div class="column-box">
      <div class="column-inner-other-user" *ngFor="let expertDeliveryRule of expertDeliveryRules, index as i">
        <div class="card-container" (click)="toggleAccordion(i)">
          <div class="action-btns">
            <div class="action-title">
              <h3>
                <b>VALET: | {{ expertDeliveryRule.expert?.user?.surname?.toUpperCase() }} {{ expertDeliveryRule.expert?.user?.name?.toUpperCase() }}</b>
              </h3>
            </div>
            <div class="action-icons">
              <i matTooltip="modifica" class="material-icons action-icon" style="color: #2196F3;" [routerLink]="['/expert/rules/edit', expertDeliveryRule.id]">edit</i>
              <i matTooltip="elemina" class="material-icons action-icon" style="color: #F44336;" (click)="$event.preventDefault(); delete(expertDeliveryRule.id)">delete</i>
              <i class="material-icons" [ngClass]="{'rotate-icon': activeAccordionActivityIndex === i}">expand_more</i>
            </div>
          </div>
        </div>
        <div class="accordion-body" *ngIf="activeAccordionActivityIndex === i">
          <div class="info-container">
            <table class="table-product" border="1">
              <thead>
                  <tr>
                    <th>Pick-Ups</th>
                    <th>Operator</th>
                    <th>Plus Salary</th>
                  </tr>
              </thead>
              <tbody >
                <tr *ngFor="let rule of getRules(expertDeliveryRule)">
                  <td>{{ rule?.pickUps }}</td>
                  <td>{{ rule?.operator | operatorTransformer }}</td>
                  <td>{{ rule?.plusSalary || "0" }} €</td>
                </tr>
              </tbody>
            </table>

            <table class="associate-valet-table" border="1">
              <thead>
                  <tr>
                    <th>Associate Valets</th>
                  </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <ng-container *ngIf="expertDeliveryRule?.associateExpertWithRule?.length > 0; else noValets">
                      <span *ngFor="let ruleExpert of expertDeliveryRule.associateExpertWithRule; let last = last">
                        {{ ruleExpert?.expert?.user?.surname?.toUpperCase() }} {{ ruleExpert?.expert?.user?.name?.toUpperCase() }}{{ !last ? ', ' : '' }}
                      </span>
                    </ng-container>
                    <ng-template #noValets>
                      <span>NO ASSOCIATE VALETS</span>
                    </ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>